import { createReducer } from '__common/utils/helpers';
import { WhatsNewActionTypes } from 'actionsConstants';

export let whatsNewState: whatsNewState = {
  open: false,
  releases: [],
  latestMajorReleaseId: null,
  hasUnseen: false,
};

export default {
  whatsNew: createReducer(whatsNewState, {
    [WhatsNewActionTypes.SET_WHATS_NEW](state: whatsNewState, action): whatsNewState {
      return {
        ...state,
        releases: action.payload.releases || [],
        latestMajorReleaseId: action.payload.latestMajorReleaseId,
        open: action.payload.open || state.open,
        hasUnseen: !!action.payload.hasUnseen,
      };
    },
    [WhatsNewActionTypes.OPEN_WHATS_NEW](state: whatsNewState): whatsNewState {
      return { ...state, open: true };
    },
    [WhatsNewActionTypes.CLOSE_WHATS_NEW](state: whatsNewState): whatsNewState {
      return { ...state, open: false };
    },
    [WhatsNewActionTypes.MARK_WHATS_NEW_SEEN](state: whatsNewState): whatsNewState {
      return { ...state, hasUnseen: false };
    },
  }),
};
